// frontend/src/components/UdemyPublishCourse.js
import React, { useState, useEffect } from 'react';

const UdemyPublishCourse = ({ course, updateCourse }) => {
  const [publishStatus, setPublishStatus] = useState('draft');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPublishStatus(course?.status || 'draft');
  }, [course]);

  const meetsRequirements = () => {
    if (!course) return false;
    
    // Verificar secciones con lecciones
    const hasSectionsWithLectures = course.sections?.some(section => 
      section.lectures?.length > 0
    );
    
    // Verificar descripción
    const hasDescription = course.description?.trim().length > 0;
    
    // Verificar precio (ahora más robusto)
    const hasValidPrice = course.price !== undefined && 
                         course.price !== null && 
                         Number(course.price) >= 0;
  
    // Verificar thumbnail (opcional por ahora)
    const hasThumbnail = true; // Temporalmente desactivado
  
    return (
      hasSectionsWithLectures &&
      hasDescription &&
      hasValidPrice &&
      hasThumbnail
    );
  };

  const handlePublish = async () => {
    if (!meetsRequirements()) {
      alert('El curso no cumple con todos los requisitos para ser publicado.');
      return;
    }

    setLoading(true);
    try {
      const updatedCourse = { 
        ...course, 
        status: 'published',
        published_at: new Date().toISOString()
      };
      await updateCourse(updatedCourse);
      setPublishStatus('published');
      alert('¡Curso publicado con éxito!');
    } catch (error) {
      console.error('Error al publicar curso:', error);
      alert('Error al publicar el curso. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (!course) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 text-center text-gray-600">
        Selecciona un curso para gestionar su publicación.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold mb-4">Publicación del curso: {course.title}</h2>

      <div className="mb-6">
        <div className="flex items-center mb-4">
          <div className={`w-3 h-3 rounded-full mr-2 ${
            publishStatus === 'published' ? 'bg-green-500' : 'bg-yellow-500'
          }`}></div>
          <span className="font-medium">
            {publishStatus === 'published' ? 'Curso publicado' : 'Borrador'}
          </span>
        </div>

        {publishStatus === 'draft' ? (
          <div className="space-y-4">
            <div className={`p-4 rounded ${meetsRequirements() ? 'bg-green-50 border border-green-200' : 'bg-yellow-50 border border-yellow-200'}`}>
              <h3 className="font-medium mb-2">Requisitos previos a la publicación</h3>
              <ul className="list-disc list-inside space-y-1">
                <li className={course.sections?.length > 0 && course.sections.some(s => s.lectures?.length > 0) ? 'text-green-700' : 'text-yellow-700'}>
                  Al menos una sección con una clase
                </li>
                <li className={course.description ? 'text-green-700' : 'text-yellow-700'}>
                  Descripción completa del curso
                </li>
                <li className={course.thumbnail_url ? 'text-green-700' : 'text-yellow-700'}>
                  Imagen del curso
                </li>
                <li className={typeof course.price === 'number' && course.price >= 0 ? 'text-green-700' : 'text-yellow-700'}>
                  Precio establecido
                </li>
              </ul>
              {!meetsRequirements() && <p className="text-red-500 mt-2">Completa los requisitos para publicar.</p>}
            </div>

            <button
              onClick={handlePublish}
              disabled={!meetsRequirements() || loading}
              className={`px-6 py-2 rounded ${meetsRequirements() ? 'bg-purple-600 hover:bg-purple-700 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
            >
              {loading ? 'Publicando...' : 'Publicar curso'}
            </button>
          </div>
        ) : (
          <div className="p-4 bg-green-50 border border-green-200 rounded">
            <h3 className="font-medium text-green-800 mb-2">¡Tu curso está publicado!</h3>
            <p className="text-green-700">Ahora los estudiantes pueden inscribirse en tu curso.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UdemyPublishCourse;